import { EuiFlexItem, EuiIcon, EuiText } from "@elastic/eui";
import React, { FC } from "react";
//@ts-expect-error - Could not find a declaration file for module 'react-currency-formatter'.
import Currency from "react-currency-formatter";

import { ActionLabel, Price } from "../utils/types";
import { priceGridStyles } from "./PriceGridStyles";

interface PriceProps {
    prices: Record<string, number | null>;
    record?: Price;
    setEditRecord?: (record: any) => void;
    getModalPrices?: (key: string, value: number, productId: string) => void;
    mode?: string;
}

interface PriceCardProps {
    label: string;
    value: number | null;
    onClick?: () => void;
    readOnly: boolean;
    deactivatedLabels?: string[];
    actionLabels?: ActionLabel[];
}

const PriceCard: FC<PriceCardProps> = ({ label, value, onClick, readOnly, deactivatedLabels, actionLabels }) => {
    if (!value) return null;

    const isDisabled = deactivatedLabels?.includes(label);
    const isDiscounted = actionLabels != null && actionLabels.find((al) => al.label === label) != null;

    return (
        <EuiFlexItem
            grow={false}
            className={["priceCard", isDisabled ? "priceCardDisabled diagonal" : ""].join(" ")}
            onClick={onClick}
            style={{ pointerEvents: readOnly ? "none" : "auto" }}
        >
            <div className="priceCardHeader">
                <strong className="priceLabel">
                    {label} {isDiscounted && "🔖"}
                </strong>
                {!readOnly && <EuiIcon color="primary" className="priceTableEditIcon" size="s" type="pencil"></EuiIcon>}
            </div>
            <EuiText color={isDiscounted ? "red" : "info"}>
                <Currency
                    quantity={isDiscounted ? actionLabels.find((al) => al.label === label)!.price : value}
                    currency="EUR"
                    locale="nl_NL"
                />
            </EuiText>
        </EuiFlexItem>
    );
};

export const PriceGrid: FC<PriceProps> = ({ prices, record, setEditRecord, getModalPrices, mode }) => {
    const handleClick = (key: string, value: number) => {
        if (mode === "cannabis" && setEditRecord && getModalPrices && record) {
            setEditRecord(record);
            getModalPrices(key, value, record.internal_product_id);
        }
    };

    const unitPriority = ["g", "j", "st"]; // g first, then j, then st

    //Sort the price cards by largest amount
    const sortedPrices = Object.fromEntries(
        Object.entries(prices).sort(([keyA], [keyB]) => {
            const getUnit = (key: string) => key.match(/[a-zA-Z]+$/)?.[0] || "";
            const getNumber = (key: string) => {
                const match = key.match(/^\d+(\.\d+)?/);
                return match ? parseFloat(match[0]) : 0.0;
            };

            const unitA = getUnit(keyA);
            const unitB = getUnit(keyB);

            const unitIndexA = unitPriority.indexOf(unitA);
            const unitIndexB = unitPriority.indexOf(unitB);

            if (unitIndexA !== unitIndexB) {
                return unitIndexA - unitIndexB;
            }
            return getNumber(keyA) - getNumber(keyB);
        })
    );
    return (
        <EuiFlexItem css={priceGridStyles}>
            <div className="priceGrid">
                {Object.keys(sortedPrices).map((key) => (
                    <PriceCard
                        key={key}
                        label={key}
                        value={prices[key]}
                        onClick={prices[key] ? () => handleClick(key, prices[key] as number) : undefined}
                        readOnly={!record}
                        deactivatedLabels={record?.deactivated_labels ?? []}
                        actionLabels={record?.action_labels ?? []}
                    />
                ))}
            </div>
        </EuiFlexItem>
    );
};
